import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useStore } from '../state/MobxContext';
import { useLocation, useNavigate } from "react-router-dom";

function SilenceLogin() {
    const { loginStore } = useStore();
    // const { CoinStore } = useStore();
    const navigate = useNavigate();

    const location = useLocation();
    const sch = location.search;

    useEffect(() => {
        
        const params = new URLSearchParams(sch);
        const login_id = params.get('login_id');
        const login_code = params.get('login_code');
        async function login() {

            if (login_id && login_code) {

                const loginRequestData = {
                    login_id: login_id,
                    login_code: login_code,
                };

                loginStore.silentLogin(loginRequestData, function (err, response) {
                    if (err) {
                        navigate('/main');
                    } else {
                        navigate('/main');
                    }
                });
            } else {
                navigate('/main');
            }
        }
        login();
    }, []);

    return (
        <div>
        </div>
    );
}

export default observer(SilenceLogin);